export const ASSESSMENT_NOTE_POINTS = [
  'Focus on the open section and review your answers before its timer ends.',
  'The next section unlocks automatically, while others remain locked.',
  'Your answers are saved automatically.',
];

export const TIMED_SECTION_SETTINGS = {
  CARRY_FORWARD: 'carry_forward',
  LOCKED: 'locked',
  DEFAULT: 'default',
};
